import type { PropsWithChildren } from 'react';
import { Wrapper, AccentBlock, Content } from './InfoSnippetLong.styles';

const InfoSnippetLong = ({ children }: PropsWithChildren) => (
  <Wrapper>
    <AccentBlock>
      <Content>{children}</Content>
    </AccentBlock>
  </Wrapper>
);

export { InfoSnippetLong };
